import { Checkbox } from '@roger/ui-components';
import { useOptionalMultiselectField } from './MultiselectFieldContext';
import { useRepeatBindings } from './repeatBindings';
import { joinClasses } from './fieldClassSlots';

export interface OASISMultiselectOptionProps {
  /** Repeat binding alias (e.g. `opt`) — resolves to `{ value, label }` from `repeat` scope */
  valueFrom: string;
  className?: string;
  /** Classes on checkbox label text */
  labelClassName?: string;
}

/** One enumerated option row for compound `OASISMultiselect` layouts (paired with JSON `repeat`). */
export function OASISMultiselectOption({
  valueFrom,
  className,
  labelClassName,
}: OASISMultiselectOptionProps) {
  const field = useOptionalMultiselectField();
  const scope = useRepeatBindings();
  const item = scope[valueFrom];

  if (!field || !item) {
    return null;
  }

  const id = `${field.qid}-${item.value}`;
  const checked = field.values.includes(item.value);
  const optionDisabled = field.disabled === true;

  return (
    <div
      className={joinClasses(
        'flex min-w-0 max-w-full items-center gap-x-2',
        className
      )}
    >
      <Checkbox
        id={id}
        checked={checked}
        disabled={optionDisabled}
        onCheckedChange={() => field.toggle(item.value)}
      />
      <label
        htmlFor={id}
        className={joinClasses(
          'text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          optionDisabled && 'cursor-not-allowed opacity-70',
          labelClassName
        )}
      >
        {item.label}
      </label>
    </div>
  );
}
